import { delayed } from "./Delay.js";

class SpawnOptions {
  constructor() {
    this.position = null;
    this.rotation = null;
    this.scale = null;
    this.visible = true;
    this.delay = 0;
    this.parent = null;
  }
}

const DefaultSpawnOptions = new SpawnOptions();

/**
 *
 */
const spawn = (caller, runtime, context) => (prefab, options = DefaultSpawnOptions) => {
  if (
    prefab !== undefined &&
    prefab !== null &&
    typeof prefab.clone === "function"
  ) {
    const newObject = prefab.clone();
    newObject.name = `${newObject.name}_${Date.now()}`;

    const { position, rotation, scale, visible } = options;

    if (position) {
      newObject.position.copy(position);
    }

    if (rotation) {
      newObject.rotation.copy(rotation);
    }

    if (scale) {
      newObject.scale.copy(scale);
    }

    newObject.visible = visible || true;

    const addToScene = () => {
      // TODO: Improve this using type check
      newObject.traverse(node => {
        if (node.code) {
          runtime.registerBehaviourNode(node, context);
        }
      });

      if (options?.parent && typeof options?.parent.add === 'function') {
        options.parent.add(newObject);
      }
      else {
        caller.add(newObject);
      }
    };

    if (options?.delay > 0) {
      delayed(addToScene, options?.delay);
    } else {
      addToScene();
    }

    return newObject;
  } else {
    throw new Error("Invalid object to instantiate");
  }
};


export { spawn };
